import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from '@ui/hooks/useStore';
import Box from '@mui/material/Box';

export default function withSections<T extends JSX.IntrinsicAttributes>(
    Component: React.FC<T>,
) {
    return observer((props: T) => {
        const { sidebar, app } = useStore();
        const isSidebarHidden = sidebar.isSidebarHidden;
        let className = isSidebarHidden ? 'sections__fullwidth' : 'sections';
        !app.cookiesApproved && (className = `${className}_with-cookies`);
        return (
            <Box className={className}>
                <Component {...props} />
            </Box>
        );
    });
}
